import { Form, Formik } from 'formik';
import { unAuthAxios } from '../../utils/axios';
import { ButtonLogin } from '../shared/buttons/ButtonLogin';
import Input from '../shared/formInput/Input';
import * as Yup from "yup";
import { Box } from '@mui/material';
import FormGroup from '../shared/containers/FormGroup';
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from '../../hooks/useAuth';
import getUserFromToken from '../../utils/getUser';
import Anchor from '../shared/buttons/Anchor';


const LOGIN_URL = "token/";

export const LoginForm = () => {
    const {setAuth} = useAuth();

    const navigate = useNavigate();
    const routerLocation = useLocation();

    const initialValues = {
        email: '',
        password: ''
    };

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
        try {
            const checkResponse = await unAuthAxios.get("user/check_only_api_access/", {params: {email: values.email}});
            let res = checkResponse.data;
            if (res.only_api_access) {
                setErrors({authError: "Compte api :\n Connexion impossible."});
                return;
            }

            const response = await unAuthAxios.post(LOGIN_URL, values);

            const accessToken = response.data?.access;
            
            if (!accessToken) return setErrors({authError: "Une erreur s'est produite !"});
            
            const refreshToken = response.data?.refresh;
            const user = getUserFromToken(accessToken);

            setAuth({accessToken, refreshToken, user});
            // redirect to previous path or to homepage if no previous paths
            const previousUrl = routerLocation?.state?.previousUrl;
            const pathAfterSuccessAuth = previousUrl && previousUrl !== "pagenotfound" ? '/' : previousUrl;
            
            navigate(pathAfterSuccessAuth, {replace: true});

        } catch (error) {
            if (!error.response) return setErrors({authError: "le serveur ne repond pas"})

            if (error.response.status === 401) {
                setErrors({authError: "Identifiants incorrects !"});
            }

            if (error.response.status === 429) {
                setErrors({authError: "Trop de tentatives de connexion.\n Réessayez dans quelques minutes."});
            }
            // console.error(error);
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("champ requis")
            .email("format: utilisateur@domaine.fr"),
        password: Yup.string()
            .required("champ requis")
    });
    

    const LoginFormStyle = {
        // border: "1px solid black", // TODO: put in theme
        border: "1px solid", // TODO: put in theme
        borderColor: "primary.main",
        borderRadius: "4px",
        width: "fit-content",
        padding: "2em",
    };

    const onClick = async (e, values, setErrors) => {
        try {
            e.preventDefault();
            const response = await unAuthAxios.get("user/check_active/", {params: {email: values.email}});
            let res = response.data;
            if (res.is_active) {
                navigate('/user/request_new_password');
            } else {
                setErrors({authError: "Identifiants incorrects!"});
            }          
            return true;
        } catch (error) {
            if (!error.response) return setErrors({authError: "le serveur ne repond pas"})

            if (error.response.status === 401) {
                setErrors({authError: "Identifiants incorrects!"});
            }
            console.error(error);
        }
    };

    return (
        <Formik {...{ initialValues, onSubmit, validationSchema }}>
            {({errors, values, isValid, dirty, setErrors}) => (
                <Box sx={LoginFormStyle}>
                    <Form>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "email",
                                    label: "Email",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input 
                                {...{
                                    name: "password",
                                    label: "Mot de passe",
                                }}
                            />
                        </FormGroup>
                        <div style={{marginBottom: '1em'}}><Anchor onClick={(e) => { onClick(e, values, setErrors)}}>Mot de passe oublié?</Anchor></div>
                        <ButtonLogin disabled={!isValid || !dirty} />
                    </Form>
                    { 
                        errors.authError && 
                            <p style={{color: 'red', textAlign: "center", marginTop: "1em", whiteSpace: "pre-wrap"}}>
                                {errors.authError}
                            </p>
                    }
                </Box>
            )}
        </Formik>
    );
}